<template>
  <div class="footer" v-if="site">
    <div class="container">
      <div class="title" v-if="site.managerName">{{ site.managerName }}</div>
      <div class="address" v-if="site.contactAddress">{{ site.contactAddress }}</div>
      <div class="contact">
        <div class="phone" v-if="site.phoneNumber"><img src="../../assets/images/icon-phone.svg" width="19" />{{ site.areaCode }} {{ site.phoneNumber }}</div>
        <div class="web" v-if="site.managerWebsite"><img src="../../assets/images/icon-global.svg" width="19" />{{ site.managerWebsite }}</div>
        <div class="email" v-if="site.managerEmail"><img src="../../assets/images/icon-email.svg" width="19" />{{ site.managerEmail }}</div>
      </div>
      <ul class="social">
        <li v-if="site.instagram">
          <a :href="site.instagram" target="_blank"><img src="../../assets/images/social1.svg" height="30" /></a>
        </li>
        <li v-if="site.facebook">
          <a :href="site.facebook" target="_blank"><img src="../../assets/images/social2.svg" height="30" /></a>
        </li>
        <li v-if="site.youtube">
          <a :href="site.youtube" target="_blank"><img src="../../assets/images/social3.svg" height="20" /></a>
        </li>
        <li v-if="site.twitter">
          <a :href="site.twitter" target="_blank"><img src="../../assets/images/social4.svg" height="24" /></a>
        </li>
        <li v-if="site.weibo">
          <a :href="site.weibo" target="_blank"><img src="../../assets/images/social5.svg" height="30" /></a>
        </li>
        <li v-if="site.line">
          <a :href="site.line" target="_blank"><img src="../../assets/images/social6.svg" height="30" /></a>
        </li>
        <li v-if="site.wechat">
          <a :href="site.wechat" target="_blank"><img src="../../assets/images/social7.svg" height="30" /></a>
        </li>
        <li v-if="site.whatsapp">
          <a :href="site.whatsapp" target="_blank"><img src="../../assets/images/social8.svg" height="30" /></a>
        </li>
      </ul>
    </div>
    <div>
      <a @click="openRule" target="_blank" :src="paypayRuleUrl" class="paypayRuleUrl">
        &lt;特定商取引法に基づく表示&gt;
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {getAction} from "@/api/manage";

export default {
  name: 'Footer',
  data() {
    return {
      paypayRuleUrl: '',
    }
  },
  computed: {
    ...mapState(['site']),
  },
  created() {
    getAction(`/pc/home/queryByUserId`, {
      // userId: this.fromId,
    }).then((res) => {
      this.paypayRuleUrl = process.env.VUE_APP_API + "/pms/view/paypayRule?id="+res.result.userId
    })
  },
  methods: {
    openRule(){
      window.open(this.paypayRuleUrl,"_blank");
    },
  },
}
</script>

<style scoped>
  .paypayRuleUrl:hover{
    cursor: pointer;
  }
</style>
